import * as Yup from "yup";

export const PhoneLoginFormValidation = (otpSent: boolean) => {
  const baseSchema = {
      phone_number: Yup.string()
        .transform((value) => {
          // Accept any international E.164 number — Asili onboards foreign
          // investors (UAE +971, etc). Local-format 0xxxxxxxxx still
          // auto-prefixes +256 for convenience.
          if (!value) return value;
          let cleaned = value.replace(/[^\d+]/g, '');
          if (/^0\d{9}$/.test(cleaned)) {
            cleaned = '+256' + cleaned.slice(1);
          } else if (!cleaned.startsWith('+')) {
            cleaned = '+' + cleaned;
          }
          return cleaned;
        })
        .matches(
          /^\+\d{10,15}$/,
          "Enter a valid international phone number (e.g. +256772123456 or +971503797047)"
        )
        .required("Phone number is required"),
  };

  if (otpSent) {
    return Yup.object().shape({
      ...baseSchema,
      otp_code: Yup.string()
        .matches(/^\d{4}$/, "OTP must be 4 digits")
        .required("OTP code is required"),
    });
  }

  return Yup.object().shape(baseSchema);
};